import { render } from "./LeaderboardCard.vue?vue&type=template&id=589f37e8&scoped=true"
import script from "./LeaderboardCard.vue?vue&type=script&lang=js"
export * from "./LeaderboardCard.vue?vue&type=script&lang=js"

import "./LeaderboardCard.vue?vue&type=style&index=0&id=589f37e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589f37e8"]])

export default __exports__